import React, { Component, type ComponentType } from 'react';
import { Field as FormField } from '@atlaskit/form';
import { Box, xcss } from '@atlaskit/primitives';
import { FormattedMessage, injectIntlV2 as injectIntl } from '@atlassian/jira-intl';
import type { Intl } from '@atlassian/jira-shared-types';
import systemFields from '../../model/system-field';
import type { FieldOperation, RelatedField, FieldId, Field } from '../../model/types';
import messages from './messages';

type RenderJqlUrl = (arg1: Field) => string;

type Props = Intl & {
	fields: FieldOperation[];
	versionName: string;
	renderVersionUrl: RenderJqlUrl;
	MoveVersion: ComponentType<{
		id: FieldId;
	}>;
};

// eslint-disable-next-line jira/react/no-class-components
export class Content extends Component<Props> {
	getFieldName(field: Field): string {
		if (systemFields.includes(field)) {
			// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ fixVersion: MessageDescriptorV2; affectedVersion: MessageDescriptorV2; multipleFieldsDescription: MessageDescriptorV2; issueCount: MessageDescriptorV2; oneFieldDescription: MessageDescriptorV2; }'.
			return this.props.intl.formatMessage(messages[field.id]);
		}

		return field.name;
	}

	renderSingleField() {
		const {
			fields: [first],
			intl: { formatMessage },
			MoveVersion,
			renderVersionUrl,
		} = this.props;

		const issueCountLink = (
			<a href={renderVersionUrl(first.relatedField.field)} target="_blank">
				{formatMessage(messages.issueCount, {
					count: first.relatedField.issueCount,
				})}
			</a>
		);

		return (
			<>
				<FormattedMessage {...messages.oneFieldDescription} values={{ issueCountLink }} />
				<Box xcss={deleteSingleOptionContainerStyles}>
					<MoveVersion id={first.relatedField.field.id} />
				</Box>
			</>
		);
	}

	renderFieldDescription(relatedField: RelatedField) {
		const { renderVersionUrl } = this.props;
		return (
			<>
				{this.getFieldName(relatedField.field)} (
				<a target="_blank" href={renderVersionUrl(relatedField.field)}>
					{relatedField.issueCount}
				</a>
				)
			</>
		);
	}

	renderMultipleFields() {
		const {
			fields,
			intl: { formatMessage },
			MoveVersion,
			versionName,
		} = this.props;
		return (
			<>
				{formatMessage(messages.multipleFieldsDescription, { name: versionName })}
				{fields.map(({ relatedField }) => (
					<div key={relatedField.field.id}>
						<FormField
							name={relatedField.field.name}
							label={this.renderFieldDescription(relatedField)}
						>
							{() => <MoveVersion id={relatedField.field.id} />}
						</FormField>
					</div>
				))}
			</>
		);
	}

	render() {
		return this.props.fields.length === 1 ? this.renderSingleField() : this.renderMultipleFields();
	}
}

export default injectIntl(Content);

const deleteSingleOptionContainerStyles = xcss({
	marginTop: 'space.200',
});
